import { BLOGS_API } from 'modules/blogs/api/blog-api'
import { BlogPagesApiInterface } from 'modules/blogs/types/blog-pages-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

interface UseBlogPagesInterface extends SwrPaginationInterface {
  id: string
}

const sortOrder = { '': 1, posts: 2, default: Number.MAX_VALUE }

export function useBlogPages({ id, pagination, limit }: UseBlogPagesInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, BlogPagesApiInterface>({
    method: RequestMethodsEnum.get,
    afterFetch: async data => {
      return {
        ...data,
        items: [
          ...data.items.sort(
            (a, b) =>
              (sortOrder[a.path as keyof typeof sortOrder] || sortOrder.default) -
              (sortOrder[b.path as keyof typeof sortOrder] || sortOrder.default),
          ),
        ],
      }
    },
  })

  const { data: blogPages, mutate: blogPagesMutate } = useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${BLOGS_API}/${id}/pages/list?pagination[limit]=${limit}`
    } else if (user && pagination.startFromId && limit) {
      return `${BLOGS_API}/${id}/pages/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    }
    return null
  }, fetcher)

  const { data: blogPagesCounter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${BLOGS_API}/${id}/pages/count?pagination[limit]`
    }
    return null
  }, baseFetcher)

  return {
    blogPages,
    blogPagesMutate,
    blogPagesCounter,
  }
}
